import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AttendanceLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'AttendaceLazy' */ './components/Attendance')
);

export default (store) => {
	return {
		path: 'attendance',
		element: <AsyncLoading component={<AttendanceLazy />} />,
	};
};
